// Lib
import React from 'react';
import MobileEmojiSheet from '../../../components/emoji/popup/MobileEmojiSheet';
import useReactionsPopupHooks from './useReactionsPopupHooks';
import { MobileReactionsSheetProps } from './reactionsPopupTypes';

const MobileReactionsSheet: React.FC<MobileReactionsSheetProps> = (props) => {
    const { elementIds, closePopup, sheetProps, gridSize } = props;

    const { selectedReactionIds, onSelectReaction } = useReactionsPopupHooks(elementIds);

    return (
        <MobileEmojiSheet
            sheetProps={sheetProps}
            selectedEmojiIds={selectedReactionIds}
            onSelectEmoji={onSelectReaction}
            closePopup={closePopup}
            gridSize={gridSize}
        />
    );
};

export default MobileReactionsSheet;
